import script from "./BattleGaugeHud.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleGaugeHud.vue?vue&type=script&setup=true&lang=js"

import "./BattleGaugeHud.vue?vue&type=style&index=0&id=0172da3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0172da3a"]])

export default __exports__